export default __webpack_public_path__ + "static/media/fire-circle-mobile.88a89536.png";